import type { QueryClient } from '@tanstack/react-query';

import { queryKeys } from '../../queryKeys';

/**
 * Celina 1.1 — the client list (the "!" and the amount still due) and the
 * desk's daily arrivals (the "!") both show the debt on the CURRENT cycle,
 * so every client-membership write that moves what is owed (a payment, a
 * void, a refund, a discount, an edit, a card link) or which cycle is
 * current (an assignment, a renewal or its undo, a replacement, an end, a
 * cancel, a freeze) stales both. Without this they keep the old mark for the
 * app-wide `staleTime` — no window-focus refetch rescues them. The arrivals
 * mark is today's debt whatever day the log shows, so every cached day goes.
 * Invalidation only: on-screen lists refetch, the rest wait.
 */
export function invalidateMembershipDebtViews(queryClient: QueryClient) {
  queryClient.invalidateQueries({
    exact: false,
    queryKey: queryKeys.organizationClients._def,
  });
  queryClient.invalidateQueries({
    exact: false,
    queryKey: queryKeys.staffHome._def,
  });
}
